export const outlineButtonStyle = {
  fontFamily: 'Borna, sans-serif',
  color: '#FFF',
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: 700,
  width: '300px',
  height: '52px',
  border: '2px solid #FFF',
  background: 'none',
  padding: '10px 0',
  borderRadius: '8px',
  cursor: 'pointer',
  outline: 'none',
  transition: 'background 0.2s',
  boxShadow: 'none',
  textTransform: 'uppercase'
}

export const submitButtonStyle = {
  fontFamily: 'Borna, sans-serif',
  height: '52px',
  fontSize: '13px',
  borderRadius: '8px',
  backgroundColor: '#5952e0',
  color: '#fff',
  fontWeight: 700,
  textTransform: 'uppercase',
  paddingTop: '10px',
  boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.08)',
  '&:hover': {
    backgroundColor: '#3C3894'
  },
  '&.Mui-disabled': {
    color: 'rgba(0, 0, 0, 0.26)',
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    boxShadow: 'none'
  }
}

export const textFieldRootStyle = {
  backgroundColor: '#fff',
  borderRadius: 4,
  minHeight: 42
}

export const textFieldInputStyle = {
  padding: '8px 12px',
  fontSize: 14,
  height: 22,
  boxSizing: 'border-box'
}
